export default {
  Inputfield: "Please enter",
  Dropdownfield: "Please select",
  Searchfield: "Search <object name>",
  createOrSelectTag: "Create or select tag",
  search: "Search...",
  searchMeasurementsOrUnits: "Search measurement units or categories",
};
